import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Seo from "./seo/Seo";
import { pageMetadata } from "./seo/metadata";
import { homeSchema } from "./seo/schema";
import NotFound from "./pages/NotFound";

// Landing Page Components
import Navbar from "./components/Navbar";
import HeroSection from "./components/sections/HeroSection";
// import CourtOwnersSection from "./components/sections/CourtOwnersSection"; // planned for a future release
import FeaturesSection from "./components/sections/FeaturesSection";
import SportsSection from "./components/sections/SportsSection";
import ScreenshotsSection from "./components/sections/ScreenshotsSection/ScreenshotsSection";
import CTASection from "./components/sections/CTASection";
import FAQSection from "./components/sections/FAQSection";
import CourtBenefitsSection from "./components/sections/CourtBenefitsSection";
import HealthSection from "./components/sections/HealthSection";
import FooterSection from "./components/sections/FooterSection";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Download from "./pages/Download";
import LegalPage from "./pages/LegalPage";
import ScrollToTop from "./components/ScrollToTop";

// Landing Page Component
function LandingPage() {
	return (
		<>
			<Seo metadata={pageMetadata.home} structuredData={homeSchema(pageMetadata.home)} />
			<div className="App">
				<Navbar />
				<main id="main-content">
					<HeroSection isDark={false} />
					<FeaturesSection isDark={true} />
					<CourtBenefitsSection />
					<SportsSection isDark={false} />
					<HealthSection />
					{/* CourtOwnersSection: hidden for now, planned for a future release */}
					<ScreenshotsSection isDark={true} />
					<FAQSection isDark={false} />
					<CTASection isDark={false} />
				</main>

				<FooterSection isDark={true} />
			</div>
		</>
	);
}

export function SiteRoutes() {
	return (
		<>
			<ScrollToTop />
			<a href="#main-content" className="skip-link">Skip to content</a>
			<Routes>
				<Route path="/" element={<LandingPage />} />
				<Route path="/blog" element={<Blog />} />
				<Route path="/blog/:slug" element={<BlogPost />} />
				<Route path="/download" element={<Download />} />
				<Route path="/privacy" element={<LegalPage documentKey="privacy" />} />
				<Route path="/terms" element={<LegalPage documentKey="terms" />} />
				{/* Keep the existing behavior for disabled court-management routes. */}
				<Route path="/login" element={<Navigate to="/" replace />} />
				<Route path="/register" element={<Navigate to="/" replace />} />
				<Route path="/sessions/*" element={<Navigate to="/" replace />} />
				<Route path="/dashboard/*" element={<Navigate to="/" replace />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</>
	);
}

function App({ RouterComponent = Router, routerProps = {}, helmetContext }) {
	return (
		<HelmetProvider context={helmetContext}>
			<RouterComponent {...routerProps}>
				<SiteRoutes />
			</RouterComponent>
		</HelmetProvider>
	);
}

export default App;
